
export default {
  SET_CENTRE_OPTIONS(room, centreOptions) {
    room.centreOptions = centreOptions
  },
}
